/**
 * Mapper API 001 (/webos/playlist) -> format items untuk Slideshow.
 *
 * Catatan: beberapa field di spec memakai suffix \"Sec\" namun contoh nilainya seperti ms.
 * Mapper ini memakai heuristik: jika angka > 300, dianggap milidetik.
 */

function guessTypeFromUrl(u) {
  const url = String(u || '').toLowerCase();
  if (url.endsWith('.m3u8')) return 'application/vnd.apple.mpegurl';
  if (/(\.mp4|\.webm|\.ogg)(\?|#|$)/.test(url)) return 'video/mp4';
  if (/(\.jpg|\.jpeg)(\?|#|$)/.test(url)) return 'image/jpeg';
  if (/(\.png)(\?|#|$)/.test(url)) return 'image/png';
  if (/(\.gif)(\?|#|$)/.test(url)) return 'image/gif';
  if (/(\.webp)(\?|#|$)/.test(url)) return 'image/webp';
  return '';
}

function durationToMs(maybeSecOrMs) {
  const n = Number(maybeSecOrMs);
  if (!Number.isFinite(n) || n <= 0) return 0;
  // Heuristic: > 300 likely milliseconds (e.g. 3000, 10000 in examples)
  if (n > 300) return Math.round(n);
  return Math.round(n * 1000);
}

export function mapWebosPlaylistToSlideshow(payload) {
  const playlist = payload?.playlist || {};
  const rawItems = Array.isArray(payload?.items) ? payload.items : [];
  const sync = payload?.sync || {};

  const playlistId = Number(playlist?.id) || 0;
  const version = playlist?.version ?? 0;
  const updatedAt = playlist?.updatedAt || '';
  const startIndex = 0; // selalu mulai dari item pertama; sync.currentIndex diabaikan

  const items = rawItems
    .slice()
    .sort((a, b) => (Number(a?.orderIndex) || 0) - (Number(b?.orderIndex) || 0))
    .map((it, i) => {
      const type = String(it?.type || '').toLowerCase();

      if (type === 'media') {
        const asset = it?.asset || {};
        const src = asset?.url || '';
        const mimeType = asset?.mimeType || guessTypeFromUrl(src) || 'application/octet-stream';
        const title = asset?.title || src.split('/').pop() || `Media ${i + 1}`;
        const poster = asset?.thumbnailUrl || '';
        const durationMs = durationToMs(it?.durationSec);

        const out = {
          id: it?.id ?? `media-${i}`,
          title,
          src,
          type: mimeType,
          fit: it?.config?.fit,
          poster: poster || undefined,
          durationMs: durationMs || undefined,
          _webos: {
            playlistId,
            itemId: Number(it?.id) || 0,
            contentId: Number(it?.contentId) || 0,
          },
        };
        return out;
      }

      if (type === 'app') {
        // Render content app via dedicated component (iframe for kindId=web).
        const url = it?.config?.param?.src || it?.asset?.link || it?.config?.url || '';
        const durationMs = durationToMs(it?.durationSec);
        return {
          id: it?.id ?? `app-${i}`,
          title: String(it?.asset?.title || 'Web Page'),
          type: 'app',
          kind: 'app',
          durationMs: durationMs || 10000,
          app: {
            kindId: it?.config?.kindId || 'web',
            src: url,
            title: String(it?.asset?.title || 'Web Page'),
            param: it?.config?.param || {},
            config: it?.config || {},
            raw: it,
          },
          _webos: {
            playlistId,
            itemId: Number(it?.id) || 0,
            contentId: Number(it?.contentId) || 0,
          },
        };
      }

      // Unknown type: skip
      return null;
    })
    .filter(Boolean);

  return {
    meta: { playlistId, version, updatedAt, fallback: !!payload?.fallback },
    sync,
    startIndex,
    items,
  };
}
